import { Skeleton } from 'antd';
import './HomePageSkeleton.css';

interface HomePageSkeletonProps {
  showBanner?: boolean;
}

const HomePageSkeleton: React.FC<HomePageSkeletonProps> = ({ showBanner = true }) => {
  return (
    <div className="home-skeleton-container">
      {/* Banner Skeleton - Hidden on mobile */}
      {showBanner && (
        <div className="home-skeleton-banner">
          <div className="home-skeleton-banner-image">
            <div className="home-skeleton-banner-placeholder" />
          </div>
          <div className="home-skeleton-banner-overlay">
            <div className="home-skeleton-banner-content">
              <Skeleton.Input active style={{ width: '60%', height: '48px' }} />
              <div className="home-skeleton-banner-description">
                <Skeleton active paragraph={{ rows: 3, width: ['100%', '90%', '75%'] }} title={false} />
              </div>
              <div className="home-skeleton-banner-author">
                <Skeleton.Avatar active size={40} />
                <Skeleton.Input active style={{ width: '150px', height: '24px' }} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content Skeleton */}
      <div className="home-skeleton-content">
        {/* Hot Campaigns Section */}
        <div className="home-skeleton-section">
          <div className="home-skeleton-section-header">
            <Skeleton.Input active style={{ width: '200px', height: '32px' }} />
            <Skeleton.Input active style={{ width: '120px', height: '40px' }} />
          </div>
          
          <div className="home-skeleton-campaigns-grid">
            {[1, 2, 3].map((index) => (
              <div key={index} className="home-skeleton-campaign-card">
                <div className="home-skeleton-campaign-image">
                  <div className="home-skeleton-image-placeholder" />
                </div>
                <div className="home-skeleton-campaign-content">
                  <Skeleton.Input active style={{ width: '80%', height: '24px' }} />
                  <Skeleton active paragraph={{ rows: 2, width: ['100%', '75%'] }} title={false} />
                  <div className="home-skeleton-campaign-footer">
                    <div className="home-skeleton-campaign-author">
                      <Skeleton.Avatar active size={32} />
                      <Skeleton.Input active style={{ width: '100px', height: '20px' }} />
                    </div>
                    <Skeleton.Input active style={{ width: '80px', height: '32px' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* More Campaigns Section */}
        <div className="home-skeleton-section">
          <div className="home-skeleton-section-header">
            <Skeleton.Input active style={{ width: '180px', height: '32px' }} />
          </div>
          
          <div className="home-skeleton-campaigns-list">
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="home-skeleton-campaign-list-item">
                <div className="home-skeleton-campaign-list-image">
                  <div className="home-skeleton-image-placeholder small" />
                </div>
                <div className="home-skeleton-campaign-list-content">
                  <Skeleton.Input active style={{ width: '70%', height: '24px' }} />
                  <Skeleton active paragraph={{ rows: 1, width: ['90%'] }} title={false} />
                  <div className="home-skeleton-campaign-list-meta">
                    <Skeleton.Avatar active size={24} />
                    <Skeleton.Input active style={{ width: '80px', height: '16px' }} />
                    <Skeleton.Input active style={{ width: '60px', height: '20px' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* My Campaigns Section (for authenticated users) */}
        <div className="home-skeleton-section">
          <div className="home-skeleton-section-header">
            <Skeleton.Input active style={{ width: '160px', height: '32px' }} />
          </div>
          
          <div className="home-skeleton-my-campaigns">
            {[1, 2].map((index) => (
              <div key={index} className="home-skeleton-my-campaign-card">
                <div className="home-skeleton-my-campaign-image">
                  <div className="home-skeleton-image-placeholder medium" />
                </div>
                <div className="home-skeleton-my-campaign-content">
                  <Skeleton.Input active style={{ width: '85%', height: '20px' }} />
                  <Skeleton active paragraph={{ rows: 1, width: ['70%'] }} title={false} />
                  <div className="home-skeleton-my-campaign-progress">
                    <Skeleton.Input active style={{ width: '100%', height: '8px' }} />
                    <Skeleton.Input active style={{ width: '80px', height: '16px' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageSkeleton;